import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Αρχική', href: '#home' },
  // { label: 'Η Ομάδα', href: '#team' },
  // { label: 'Παραστάσεις', href: '#shows' },
  // { label: 'Εργαστήρια', href: '#workshops' },
  // { label: 'Box Office', href: '#boxoffice' },
  { label: 'Επικοινωνία', href: '#contact' },
];

const LOGO_URL = 'https://i.ibb.co/YFHLQ248/blanda-logo.png';

export default function Navbar({ active, onNav, isHomePage }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const handleClick = (href) => {
    onNav(href);
    setMenuOpen(false);
  };

  // Transparent + white text when on homepage carousel, dark otherwise
  const isTransparent = isHomePage && !scrolled;

  const linkColor = 'rgba(255,255,255,0.80)';
  const linkActiveColor = 'white';
  const hamburgerColor = 'white';

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        padding: scrolled ? '10px 48px' : '20px 48px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: isTransparent ? 'transparent' : 'rgba(26,23,20,0.92)',
        borderBottom: isTransparent ? '1px solid transparent' : '1px solid rgba(255,255,255,0.07)',
        transition: 'all 0.4s ease',
        backdropFilter: isTransparent ? 'none' : 'blur(10px)',
      }}>
        <button onClick={() => handleClick('#home')}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}>
          <img src={LOGO_URL} alt="BLANDA"
            style={{ height: scrolled ? '54px' : '80px', width: 'auto', transition: 'height 0.4s ease' }} />
        </button>

        <ul style={{ display: 'flex', gap: '36px', listStyle: 'none', alignItems: 'center' }} className="nav-desktop">
          {navLinks.map(link => (
            <li key={link.href}>
              <NavLink link={link} active={active}
                color={linkColor} activeColor={linkActiveColor}
                hoverColor='white'
                onClick={() => handleClick(link.href)} />
            </li>
          ))}
        </ul>

        <button className="nav-hamburger" onClick={() => setMenuOpen(!menuOpen)}
          style={{ display: 'none', flexDirection: 'column', gap: '5px', background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
          aria-label="Toggle menu">
          {[0, 1, 2].map(i => (
            <span key={i} style={{
              display: 'block', width: '24px', height: '1px', background: hamburgerColor, transition: 'all 0.3s',
              transform: menuOpen && i === 0 ? 'rotate(45deg) translate(4px, 4px)' :
                         menuOpen && i === 1 ? 'scaleX(0)' :
                         menuOpen && i === 2 ? 'rotate(-45deg) translate(4px, -4px)' : 'none',
            }} />
          ))}
        </button>
      </nav>

      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'var(--white)', zIndex: 99,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '32px',
        transform: menuOpen ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.4s cubic-bezier(0.77, 0, 0.175, 1)',
      }}>
        <img src={LOGO_URL} alt="BLANDA" style={{ height: '80px', width: 'auto', marginBottom: '16px' }} />
        {navLinks.map(link => (
          <button key={link.href} onClick={() => handleClick(link.href)} style={{
            fontFamily: 'var(--font-display)', fontSize: '2.2rem', fontWeight: 400, letterSpacing: '0.06em',
            color: active === link.href ? 'var(--accent)' : 'var(--black)',
            background: 'none', border: 'none', cursor: 'pointer',
          }}>
            {link.label}
          </button>
        ))}
      </div>

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
          .nav-hamburger { display: flex !important; }
        }
      `}</style>
    </>
  );
}

function NavLink({ link, active, color, activeColor, hoverColor, onClick }) {
  const [hovered, setHovered] = useState(false);
  const isActive = active === link.href;
  return (
    <button onClick={onClick}
      onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      style={{
        fontFamily: 'var(--font-body)', fontSize: '0.72rem', letterSpacing: '0.12em', textTransform: 'uppercase',
        color: hovered ? hoverColor : isActive ? activeColor : color,
        background: 'none', border: 'none', cursor: 'pointer', padding: '4px 0',
        borderBottom: isActive ? `1px solid ${activeColor}` : '1px solid transparent',
        transition: 'color 0.2s, border-color 0.2s',
      }}>
      {link.label}
    </button>
  );
}
